import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=ddd4295a&scoped=true"
import script from "./tableData.vue?vue&type=script&lang=js"
export * from "./tableData.vue?vue&type=script&lang=js"
import style0 from "./tableData.vue?vue&type=style&index=0&id=ddd4295a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd4295a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ddd4295a')) {
      api.createRecord('ddd4295a', component.options)
    } else {
      api.reload('ddd4295a', component.options)
    }
    module.hot.accept("./tableData.vue?vue&type=template&id=ddd4295a&scoped=true", function () {
      api.rerender('ddd4295a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/transfer/base/components/tableData.vue"
export default component.exports